import { memo, useContext, useEffect, useState } from 'react';

import ListItemText from '@mui/material/ListItemText';
import { SidebarContext } from '../../context';
import { SidebarNavItemProps } from '../../props';
import { StyledListItemButton } from './styled';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { useQueryState } from 'nuqs';
import tid from '@/common/infrastructure/config/tid';

const SidebarNavItem = ({ item, level }: SidebarNavItemProps) => {
  const { sidebarOpen } = useContext(SidebarContext);

  const [subModule] = useQueryState('submodule');

  const [isSelected, setIsSelected] = useState(false);

  useEffect(() => {
    setIsSelected(subModule === item.id);
  }, [subModule]);

  const iconSelectedColor = 'white';

  const navigate = useNavigate();

  // Lightweight chunk prefetch on hover for common heavy routes
  const prefetch = (path?: string) => {
    if (!path) return;
    try {
      if (path.startsWith('/jobs')) {
        void import('@/jobs/presentation/pages/JobsPage/JobsTableTab');
        void import('@/jobs/presentation/pages/Timeline');
      } else if (path.startsWith('/customers')) {
        void import('@/customers/presentation/pages/CustomersPage/CustomersManagementTab');
      } else if (path.startsWith('/equipments')) {
        void import('@/equipments/presentation/pages/EquipmentPage/EquipmentManagementTab');
      } else if (path.startsWith('/employees')) {
        void import('@/employees/presentation/pages/EmployeesPage');
      } else if (path.startsWith('/job-sites')) {
        void import('@/jobSites/presentation/pages/JobSitesPage/JobSitesManagementTab');
      }
    } catch {
      // Best-effort prefetch; ignore failures
    }
  };

  return (
    <StyledListItemButton
      role="menuitem"
      disabled={item.disabled}
      disableRipple={!sidebarOpen}
      selected={isSelected}
      onMouseEnter={() => prefetch(item.url)}
      onClick={() => {
        if (!item.disabled) {
          navigate(item.url!);
        }
      }}
      {...tid(`common:layout:sidebar-nav-item:button-${item.id}`)}
    >
      {(sidebarOpen || (!sidebarOpen && level !== 1)) && (
        <ListItemText
          primary={
            <Typography
              noWrap
              overflow="hidden"
              textOverflow="ellipsis"
              variant={'body1'}
              width={240}
              sx={{ color: iconSelectedColor, '& .MuiTypography-root': { color: iconSelectedColor } }}
            >
              {item.title}
            </Typography>
          }
        />
      )}
    </StyledListItemButton>
  );
};

export default memo(SidebarNavItem);
